import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import SrLink from 'client/components/SrLink/SrLink';

class SrCtaStepsBlock extends Component {
  static propTypes = {
    headline: PropTypes.string.isRequired,
    steps: PropTypes.arrayOf(PropTypes.shape({
      text: PropTypes.string.isRequired,
      completed: PropTypes.bool.isRequired,
      linkTo: PropTypes.string,
      onClick: PropTypes.func,
    })).isRequired,
  }

  render() {
    const { headline, steps } = this.props;
    const nextActiveStepIndex = steps.findIndex(({ completed }) => !completed);
    return (
      <div className='SrCtaStepsBlock'>
        <span className='ctaStepsBlockHeadline'>{headline}</span>
        {steps.map(({ text, completed, linkTo, onClick }, index) => (
          <div
            key={text}
            className={classnames({
              stepRow: true,
              active: index === nextActiveStepIndex,
              completed: completed,
              last: index === steps.length - 1,
            })}
          >
            <div className='checkbox' />
            {linkTo && !completed
              ? <SrLink onClick={completed ? null : onClick} to={linkTo}>{text}&nbsp;→</SrLink>
              : <span onClick={completed ? null : onClick}>{text}&nbsp;{completed ? null : '→'}</span>
            }
          </div>
        ))}
      </div>
    );
  }
}

SrCtaStepsBlock.displayName = 'SrCtaStepsBlock';

export default SrCtaStepsBlock;
